import { createNullableProvideInject } from '@collector/shared-ui'

import { IncidentIdsGroup } from '../configuration'

export const [provideIncidentIdsGroup, injectIncidentIdsGroup] =
  createNullableProvideInject<IncidentIdsGroup>('incidentIdsGroup')
